import { Badge, type BadgeTone } from './badge'

const TYPE_CONFIG: Record<string, { label: string; tone: BadgeTone }> = {
  ADVANCE: { label: 'Adiantamento', tone: 'info' },
  BALANCE: { label: 'Saldo', tone: 'purple' },
}

interface RepaymentTypeBadgeProps {
  readonly type: string
}

export function RepaymentTypeBadge({ type }: RepaymentTypeBadgeProps) {
  const config = TYPE_CONFIG[type] ?? { label: type, tone: 'neutral' as const }
  return <Badge tone={config.tone}>{config.label}</Badge>
}

const STATUS_CONFIG: Record<string, { label: string; tone: BadgeTone }> = {
  PAID: { label: 'Pago', tone: 'success' },
  PENDING: { label: 'Pendente', tone: 'warning' },
  BLOCKED: { label: 'Bloqueado', tone: 'danger' },
}

interface RepaymentStatusBadgeProps {
  readonly status: string
}

export function RepaymentStatusBadge({ status }: RepaymentStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG['PENDING']
  return <Badge tone={config.tone}>{config.label}</Badge>
}
